//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
	name: "organisations-slug-info",
	components: {},
	props: {
		slug: {
			type: String,
			required: true,
		},
		organisation: {
			type: Object,
			required: true,
		},
		ranking: {
			type: Object,
			required: true,
		},
	},
	head() {
		return {
			title: `${this.$t(`about`)} – ${this.organisation.name} – VoteLog`,
		};
	},
	nuxtI18n: {
		paths: {
			en: "/organisations/:slug/information",
			de: "/organisationen/:slug/information",
			fr: "/organisations/:slug/information",
			it: "/organizzazioni/:slug/informazione",
		},
	},
};
